module.exports = __webpack_public_path__ + "img/bank.3ac7bdf9.png";